import MailTrackingService from '@ve/services/analytics/mailAnalytics/MailTrackingService';

export default class HotelPagePriceJumpTrackingService extends MailTrackingService {
    hotelPageTourProductMinPrice = 0

    public setHotelPageTimeoutViewPageEvent(price: number | null, hotelId: number): void {
        if (price) {
            this.updatePrice(price);
        }

        setTimeout(() => {
            this.viewPage(hotelId);
        }, 3000);
    }

    public updatePrice(price: number): void {
        this.hotelPageTourProductMinPrice = price;
    }

    private viewPage(hotelId: number): void {
        const params = this.getParams(this.hotelPageTourProductMinPrice, hotelId, 'hotelPage');

        this.sendAnalytics(params);
    }
}
